var exports = {};

function cubicIn(t) {
  return t * t * t;
}

exports = cubicIn;
export default exports;